import React from 'react'
import { Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  root: {
    color: palette.common.black,
    fontWeight: typography.fontWeightBold,
    ...typography.body.s,
    marginBottom: spacing(3)
  }
}))

const Prompt = ({ prompt, ...props }) => {
  const classes = useStyles()
  return (
    <Typography className={classes.root} {...props}>
      {prompt}
    </Typography>
  )
}

export default Prompt
